import { SeeqNames } from '@/main/app.constants.seeqnames';

export const HeadlessCategories = [
  SeeqNames.Origins.Screenshot as string,
  SeeqNames.Origins.Thumbnail as string,
  SeeqNames.Origins.ScreenshotPowerpoint as string,
] as const;
export type HeadlessCategory = (typeof HeadlessCategories)[number];

export enum HeadlessJobFormat {
  PNG = 'PNG',
  PDF = 'PDF',
  REACT_JSON = 'REACT_JSON',
}
